import type { TFunction } from 'i18next';
import { extractErrorMessage } from './error.utils';

interface ApiErrorBody {
  response?: {
    data?: {
      error?: {
        message?: string;
        code?: string;
      };
      message?: string;
    };
  };
}

const RS_ERROR_CODE_PREFIX = 'reservation.errors.';

/**
 * 予約システム API エラーを locale 文言に変換する。
 * error.response.data.error.code が reservation.errors.* のとき t(code) を返す。
 */
export function extractReservationErrorMessage(err: unknown, t: TFunction, defaultMessage: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const apiError = err as ApiErrorBody;
    const code = apiError.response?.data?.error?.code;
    if (typeof code === 'string' && code.startsWith(RS_ERROR_CODE_PREFIX)) {
      return t(code, { defaultValue: defaultMessage });
    }
  }
  return extractErrorMessage(err, defaultMessage);
}
